<app-metformin
  htmlTitle="<strong>Important: Enhance</strong> Fat Loss, Energy, and Metabolic Control"
  question="We strongly recommend including Metformin in your prescription. Would you like to add it to your treatment plan?"
>
  <p class="mb-4">
    Many men on testosterone therapy notice changes in appetite, body composition, or energy as their hormones
    rebalance. Optimizing metabolism is one of the fastest ways to improve results on TRT and
    <strong>Metformin</strong> is one of the most trusted tools to help you get there.
  </p>
  <p class="mb-4">
    Adding <strong>Metformin</strong> to your treatment plan can support steadier blood sugar, improved insulin
    sensitivity, and more efficient fat metabolism. Many patients experience easier weight control, fewer cravings,
    smoother energy levels, and better overall metabolic performance. For men on TRT, this often translates to
    <strong>leaner results, stronger workouts, and more consistent day-to-day energy.</strong>
  </p>
  <p class="mb-4">
    This option includes a convenient supply of medication with an excellent safety profile and decades of clinical use
    behind it.
  </p>
</app-metformin>
